module.exports = __webpack_public_path__ + "img/item-loading.d7911bdc.svg";